export default __webpack_public_path__ + "static/media/offing-joshua-nguyen.e22e3bab.webp";